/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon20Solid = forwardRef('WeatherUmbrellaIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.125 1.5a1.125 1.125 0 0 0-2.25 0v1.32a8.878 8.878 0 0 0-7.719 8.054A1.042 1.042 0 0 0 2.197 12h6.678v4.25a.875.875 0 1 1-1.75 0c0-.69-.326-1.375-1.125-1.375-.8 0-1.125.685-1.125 1.375a3.125 3.125 0 1 0 6.25 0V12h6.677c.592 0 1.094-.5 1.042-1.126a8.878 8.878 0 0 0-7.719-8.053V1.5Z" })));
});
